<div class="cardLayout">
  <ion-row>
    <ion-col size="12">
      <div class="popup-heading">
        <div>
          <p class="fs-16 fs_14ForMobile font_regular" *ngIf="!SocialFeedId">Add New Social Feed</p>
          <p class="fs-16 fs_14ForMobile font_regular" *ngIf="SocialFeedId">Edit Social Feed</p>
        </div>
        <div class="popup-close">
          <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <div class="padding">
    <!-- <ion-row>
      <ion-col size="12">
        <div >
          <p class="fs-16 fs_14ForMobile font_bold" *ngIf="!onDisabledSocialFeeds">Edit</p>
        </div>
      </ion-col>
    </ion-row> -->
    <ion-row>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="fs14 font_semibold mb-5 mt-10">Social Feed Type<span class="red-cl">&nbsp;*</span>
        </div>
        <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
          <mat-select placeholder="Select Social Feed" [(ngModel)]="SocialFeedType" [disabled]="onDisabledSocialFeeds">
            <mat-option value="Twitter">Twitter</mat-option>
            <mat-option value="Fb">Facebook</mat-option>
            <mat-option value="Youtube">YouTube</mat-option>
            <mat-option value="Instagram">Instagram</mat-option>
            <mat-option value="External_Link">External Links</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="fs-14 fs_12ForMobile pt-5 red" *ngIf="isInvalidSocialFeedType">Select Social Feed Type</div>
      </ion-col>
      
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="fs14 font_semibold mb-5 mt-10">Social Feed Name<span class="red-cl">&nbsp;*</span>
        </div>
        <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
          <input matInput  placeholder="Type here" [(ngModel)]="SocialFeedName" [disabled]="onDisabledSocialFeeds">
        </mat-form-field>
        <div class="fs-14 fs_12ForMobile pt-5 red" *ngIf="isInvalidSocialFeedName">Enter Social Feed Name</div>
      </ion-col>
      
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="fs14 font_semibold mb-5 mt-10">Social Feed URL<span class="red-cl">&nbsp;*</span>
        </div>
        <mat-form-field class="w-100 mt-5 mat-height40 mat-input-style">
          <input matInput  placeholder="Type here" [(ngModel)]="SocialFeedURL" [disabled]="onDisabledSocialFeeds">
        </mat-form-field>
        <div class="fs-14 fs_12ForMobile pt-5 red" *ngIf="isInvalidSocialFeedURL">Enter Social Feed URL</div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
        <div class="fs14 font_semibold mb-5 mt-10">Remarks</div>
        <mat-form-field class="w-100  mat-input-style">
          <textarea matInput placeholder="Description" rows="4" [(ngModel)]="SocialFeedReamarks" [disabled]="onDisabledSocialFeeds"></textarea>
        </mat-form-field>
      </ion-col>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <div class="btnGroup"  *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'Admin' || loggedInUserRole == 'PHI Admin'">
          <button type="button" class="cancleBtn"(click)="onClickCancelSocialFeed()">Cancel</button>
          <button type="button" class="saveBtn" (click)="onClickSaveSocialFeed()">Save</button>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>